// --- React & Redux
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
// --- External UI Libraries
import Banner from '@dtci/spellbook/Banner';
import ContentBlock from '@dtci/spellbook/ContentBlock';
import DataGrid from '@dtci/spellbook/DataGrid';
import Typography from '@dtci/spellbook/Typography';
// --- Hooks & Config
import { useAgGridApi } from 'datastage/components/AGGrid/hooks';
import * as columnDefs from 'datastage/components/AGGrid/config/columns-def';
// --- Styles
import styles from 'datastage/components/AGGrid/details-table.module.scss';

/**
 * Deal DRO Changes Grid
 *
 * Features:
 * - Displays a data grid of Deal DRO Changes using AG Grid
 * - Integrates with Redux for Deal DRO Changes state management
 *
 * @returns {Element}
 * @constructor
 */
export const DealDROChangesGrid = () => {
    const agGridApi = useAgGridApi();    
    const { dealDROChanges } = useSelector((s) => s.dealDROChanges);    
    const [banner, setBanner] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);  

    const handleClose = () => {
        agGridApi.AgGridApiRef.current.api.deselectAll();
        setBanner(null);
        setSelectedRows([]);
    };

    return (
        <>
            {banner && (
                <Banner
                    faPackage="far"
                    iconTypePrimary={
                        selectedRows.length === 1 ? 'fa-times-circle' : 'fa-check-circle'
                    }
                    role="status"
                    type={selectedRows.length === 1 ? 'warning' : 'success'}
                    onClose={handleClose}
                    style={{
                        width: '100%',
                        minHeight: 48,
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 12,
                        padding: '12px 20px',
                        boxSizing: 'border-box',
                    }}
                >
                    <ContentBlock
                        className="banner-content"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            gap: 12,
                            width: '100%',
                            minHeight: 48,
                        }}
                    >
                        <Typography className="main-banner-text" variant="T20">
                            {banner}
                        </Typography>                        
                    </ContentBlock>
                </Banner>
            )}
            <DataGrid
                className={styles.dataGrid}                
                autoSizing
                agGrid={{
                    ref: agGridApi.AgGridApiRef,
                    rowData: dealDROChanges,
                    headerHeight: 45,
                    defaultColDef: {
                        wrapText: true,
                        autoHeight: true,
                        suppressMenu: true,
                        resizable: true,
                        cellStyle: { 
                            paddingTop: '10px', 
                            paddingBottom: '10px',
                            wordBreak: 'normal',
                            overflowWrap: 'break-word',
                        },
                    },
                }}
                bordered="none"                
                columnDefs={columnDefs['dealDROChanges']()['default']}
                sortable
                striped
            />            
        </>
    );
};
